import { Button, Card, Col, Flex, List, Modal, Row, notification } from "antd";
import React, { useState } from "react";
import { HubspotWhiteIcon } from "../../../Icon/Icon";
import { CloseCircleOutlined, CheckCircleTwoTone } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { sendCandidates } from "api/smart.api";
import TagList from "./TagList";
import ExpandableButton from "components/Common/Button/ExpandableButton";
import { SvgIcons } from "Icon/SvgIcons";
interface Props {
  selectedCandidateList: any[];
  roleId: any;
  allIdsSelected?: any;
  isExpanded?: boolean;
}

export const HubspotATS: React.FC<Props> = ({
  selectedCandidateList,
  roleId,
  allIdsSelected,
  isExpanded,
}) => {
  const { t } = useTranslation();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState<any>(null);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };

  const openNotification = (responseData: any) => {
    notification.open({
      message: "Hubspot",
      description: (
        <List
          itemLayout="horizontal"
          dataSource={responseData ? responseData : []}
          renderItem={(item: any, index) => (
            <List.Item>
              <List.Item.Meta
                title={item.candidate_name}
                avatar={
                  item.reason ? (
                    <CloseCircleOutlined twoToneColor="#FF0000" size={25} />
                  ) : (
                    <CheckCircleTwoTone twoToneColor="#52C41A" size={25} />
                  )
                }
                description={
                  item.reason ? item.reason : t("candidate") + ` sent successfully to Hubspot`
                }
              />
            </List.Item>
          )}
        />
      ),
    });
  };
  const openNotificationError = () => {
    notification.error({
      message: "Hubspot",
      description: `Something went wrong when sending candidate to Hubspot`,
    });
  };
  const handleSendToSmartRecruiter = async () => {
    if (selectedTags) {
      setConfirmLoading(true);
      try {
        const data = await sendCandidates({
          candidates: selectedCandidateList,
          tags: [selectedTags],
          select_all: allIdsSelected,
          project_id: roleId,
        });
        openNotification(data);
        setConfirmLoading(false);
        hideModal();
      } catch (error) {
        setConfirmLoading(false);
        openNotificationError();
      }
      setConfirmLoading(false);
      hideModal();
    } else {
      // Handle case where project and tags are not selected
      console.error("Please select a project and at least one tag.");
    }
  };
  return (
    <>
      <ExpandableButton
        icon={<HubspotWhiteIcon size={20} />}
        // loading={loadingReject}
        text={"Hubspot"}
        onClick={() => {
          showModal();
        }}
        disabled={selectedCandidateList.length === 0}
        isExpanded={isExpanded}
      />
      <Modal
        className="add-candidate-model"
        title={
          <Flex gap={20} className="pb-5">
            {SvgIcons.featuredCheckIcon}
            <Flex vertical>
              <span className="text-lg text-fonttext-primary font-semibold">
                Move Candidate(s) to Hubspot
              </span>
              <span className="text-sm text-text-tertiary font-normal">
                Select the lead status before sending candidates to the Hubspot.
              </span>
            </Flex>
          </Flex>
        }
        footer={null}
        // title="Export Profile"
        visible={isModalOpen}
        onCancel={hideModal}
        style={{ top: 20 }}
      >
        <Card
          id="smart-req-card"
          style={{
            boxShadow: "none",
          }}
          bordered={false}
          bodyStyle={{ padding: 0 }}
        >
          <Row gutter={24}>
            <Col span={24} className="addToRole">
              <Card
                title={false}
                bordered={false}
                style={{
                  boxShadow: "none",
                }}
                bodyStyle={{ padding: "0", maxHeight: "auto !important" }}
              >
                <span className="text-lg text-fonttext-primary font-semibold">
                  Select Lead Status
                </span>
                <TagList
                  onSelect={(project: string) => setSelectedTags(project)}
                  selectedTags={selectedTags}
                  isRadio={true}
                  placeholder="Start Typing Lead Status..."
                />
              </Card>
            </Col>
          </Row>
        </Card>
        <Row align="middle" className="pt-8">
          <Button className="m-1 flex-grow" loading={confirmLoading} onClick={hideModal}>
            Cancel
          </Button>
          <Button
            type="primary"
            className="m-1 flex-grow"
            disabled={!selectedTags}
            loading={confirmLoading}
            onClick={handleSendToSmartRecruiter}
          >
            Send To Hubspot
          </Button>
        </Row>
      </Modal>
    </>
  );
};
